import {FC} from 'react';
import dayjs from 'dayjs';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {
	ADDED,
	ADDRESS,
	BODY1,
	CITY,
	EDIT,
	EMAIL,
	H5,
	MEAL,
	MM_DD_YYYY,
	PHONE_NUMBER,
	STATE,
	ZIP,
} from '@/utils/constants';
//types
import {IOrganizationContact} from '@/utils/types';
//styles
import {contactDetailsStyle} from './ContactDetails.styles';

interface ContactDetailsProps {
	detailsContact: IOrganizationContact | null;
}

const ContactDetails: FC<ContactDetailsProps> = ({detailsContact}) => {
	const contactNameTitle = `${detailsContact?.firstName} ${detailsContact?.lastName}`;

	return (
		<Box sx={contactDetailsStyle.wrapper}>
			<Typography variant={H5} sx={contactDetailsStyle.title}>
				{contactNameTitle}
			</Typography>

			<Box sx={contactDetailsStyle.content}>
				<Box sx={contactDetailsStyle.details}>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{EMAIL}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.email}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{PHONE_NUMBER}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.phoneNumber}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{MEAL}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.meals.join(', ')}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{ADDRESS}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.address}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{CITY}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.city}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{STATE}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.state}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{ZIP}
						</Typography>
						<Typography variant={BODY1}>{detailsContact?.zip}</Typography>
					</Box>
				</Box>
				<Box sx={contactDetailsStyle.details}>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{ADDED}
						</Typography>
						<Typography variant={BODY1}>{dayjs(detailsContact?.added).format(MM_DD_YYYY)}</Typography>
					</Box>
					<Box sx={contactDetailsStyle.info}>
						<Typography variant={BODY1} sx={contactDetailsStyle.infoName}>
							{EDIT}
						</Typography>
						<Typography variant={BODY1}>{dayjs(detailsContact?.edited).format(MM_DD_YYYY)}</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default ContactDetails;
